<template>
    <b-container fluid v-if="client" class="align-self-center">
        <b-row>
            <b-col cols="12">
                <h2 class="text-center my-4">Edit client</h2>
            </b-col>
            <b-col md="12" class="flex-center">
                <b-form v-on:submit.prevent="updateClient" class="w-75">
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Name:"
                        label-for="name">
                        <b-form-input id="name"
                                      type="text"
                                      size="sm"
                                      name="name"
                                      :value="client.name"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Address:"
                        label-for="address">
                        <b-form-input id="address"
                                      type="text"
                                      size="sm"
                                      name="address"
                                      :value="client.address"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Owner:"
                        label-for="owner">
                        <b-form-input id="owner"
                                      type="text"
                                      size="sm"
                                      name="owner"
                                      :value="client.owner"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Contact:"
                        label-for="contact">
                        <b-form-input id="contact"
                                      type="text"
                                      size="sm"
                                      name="contact"
                                      :value="client.contact"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-btn type="submit" variant="primary" class="pull-right">Confirm</b-btn>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        data() {
            return {
                client: null
            }
        },
        methods: {
            updateClient: function (e) {
                const formData = new FormData(e.target);
                adamApi.post(api.clients + this.$route.params.id, formData).then( response => {
                        if (response.status === 200) {
                            this.$router.push('/clients/' + response.data.id);
                        }
                    }
                )
            }
        },
        created () {
            adamApi.get(api.clients + this.$route.params.id).
            then(response => {
                if (response.status === 200) {
                    this.client = response.data;
                }
            })
        }
    }
</script>
